/**
 * Extract unique simple course IDs from course thumbnails categories.
 * Used for Continue watch and course progress queries.
 */
export function extractSimpleCourseIds(
  categories: Array<{ courses: { id: number }[] }> | undefined
): number[] {
  return (categories || [])
    .flatMap((cat) => cat.courses.map((c) => c.id))
    .filter((id, index, arr) => arr.indexOf(id) === index);
}
